export const GET_SUGGESTED_LINKS = 'GET_SUGGESTED_LINKS'
export const GET_SUGGESTED_LINKS_PENDING = 'GET_SUGGESTED_LINKS_PENDING'
export const GET_SUGGESTED_LINKS_FULFILLED = 'GET_SUGGESTED_LINKS_FULFILLED'
export const GET_SUGGESTED_LINKS_REJECTED = 'GET_SUGGESTED_LINKS_REJECTED'

export type SuggestedLink = {
  candidate_link_type_id: number
  text: string
}

export type SuggestedLinkResponse = {
  data: SuggestedLink[]
  org_total_links_count?: number
  success?: boolean
  statusCode?: number
}
